import axios from 'axios';
import Cookies from 'js-cookie';
import { debug } from 'util';
// import { store } from '../store/store'; // Adjust the import path as needed

 //import { SessionStorage } from './SessionStorage';

const url = process.env.REACT_APP_API_BASE_URL;
let requestCounter = 0
// Set withCredentials to true for all requests
axios.defaults.withCredentials = true;

export const OneEyeService = axios.create({
    baseURL: url,
    headers: {
        'Content-Type': "application/json",
        'Access-Control-Allow-Origin': '*',
        
    }
})
// OneEyeService.interceptors.request.use(function (config) {
//     requestCounter++;
//     document.body.classList.add('loading-indicator');

//     // Get the JWT token from Redux store
//     const token = store.getState().user.token; // Update the path based on your state structure

//     if (token) {
//         config.headers.Authorization = `Bearer ${token}`;
//     }

//     return config;
// }, function (error) {
//     return Promise.reject(error);
// });


OneEyeService.interceptors.request.use(function (config) {

    requestCounter++
    document.body.classList.add('loading-indicator');
    const token = Cookies.get('JwtToken');
    //const token = Cookies.get('AuthToken');
    
    if(!token)
    {
        // 
    //  token = Cookies.get('AuthToken');
    }
    console.log(token,"ALI")
    if (token) {
        config.headers.Authorization = `Bearer ${token}`
    }
    return config
}, function (error) {
    return Promise.reject(error);
});

OneEyeService.interceptors.response.use(function (response) {

    requestCounter--;
    if (requestCounter === 0)
        document.body.classList.remove('loading-indicator');
    return response;
}, function (error) {
    requestCounter--;
    if (requestCounter === 0)
        document.body.classList.remove('loading-indicator');

    return Promise.reject(error);
});


